import React from "react";
import { Fuel, Network, Warehouse, Globe2, ArrowUpRight } from "lucide-react";

const METIERS = [
  {
    icon: Fuel,
    title: "Distribution de carburant",
    desc: "Licence exclusive Wayne pour la Côte d'Ivoire. Gamme complète de distributeurs nouvelle génération : lubrifiants haute performance, carburant, consommables automobiles — installation, mise en service et maintenance.",
  },
  {
    icon: Network,
    title: "Réseau de stations-services",
    desc: "Développement d'un réseau de stations Wayne à travers le territoire national : carburant, bornes électriques, point vidanges, point automotive, boutiques intégrées, services de proximité et expérience client premium.",
  },
  {
    icon: Warehouse,
    title: "Infrastructure pétrolière",
    desc: "Capacités de stockage carburant et gaz, logistique d'approvisionnement, construction et gestion de dépôts aux normes internationales.",
  },
  {
    icon: Globe2,
    title: "Trading pétrolier",
    desc: "Négoce de produits pétroliers bruts et raffinés. Partenariats commerciaux stratégiques en Afrique de l'Ouest et à l'international.",
  },
];

export default function Metiers() {
  return (
    <section
      id="metiers"
      data-testid="metiers-section"
      className="bg-[#F5F6F8] py-24 sm:py-28"
    >
      <div className="kip-container">
        <div className="max-w-3xl mb-14 reveal">
          <span className="kip-overline">Nos Métiers</span>
          <span className="kip-accent-bar mt-4" />
          <h2 className="font-display font-black text-[#1A2744] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            Quatre pôles pour un écosystème énergétique complet.
          </h2>
          <p className="mt-4 text-[#64748B] text-lg max-w-2xl">
            De la distribution d'équipements à la vente au détail, KIP Energy
            couvre toute la chaîne de valeur pétrolière en Côte d'Ivoire.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {METIERS.map((m, i) => (
            <article
              key={m.title}
              data-testid={`metier-card-${i}`}
              className="group relative bg-white border-t-4 border-[#E85D26] p-8 lg:p-10 shadow-sm hover:shadow-xl transition-all duration-300 reveal"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#E85D26]/10 text-[#E85D26]">
                  <m.icon size={26} strokeWidth={1.8} />
                </div>
                <span className="text-xs font-mono text-[#64748B]">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display font-bold text-[#1A2744] text-2xl mb-3 tracking-tight">
                {m.title}
              </h3>
              <p className="text-[#334155] leading-relaxed text-[15px]">
                {m.desc}
              </p>
              <div className="mt-6 pt-5 border-t border-[#F5F6F8] flex items-center justify-between text-sm">
                <span className="text-[#E85D26] font-semibold uppercase tracking-wider">
                  En savoir plus
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-[#E85D26] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
